export const getDefaultState = () => {
    return {
        orderSubMaintences: [],
        orderSubMaintence: {

        },
        validation_provider: {

        },
    }
}
export default getDefaultState()
